import React from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    Button,
    Box,
    CircularProgress,
    Typography,
} from '@mui/material';
import { ReactComponent as TrashIcon } from '../../assets/images/icon_trash.svg';

const deleteButtonSx = {
    backgroundColor: '#DF352C',
    borderRadius: '5px',
    color: '#FFF',
    boxShadow: 'none',
    fontWeight: 600,
    width: '248px',
    '&:hover': {
        backgroundColor: '#F18A82',
        boxShadow: 'none',
    },
    '&:focus': {
        boxShadow: 'none',
        outline: 'none',
    },
};

const cancelButtonSx = {
    fontWeight: 600,
    color: 'rgba(17, 17, 17, 0.60)',
    border: '1px solid rgba(17, 17, 17, 0.60)',
    width: '196px',
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '&:focus': {
        outline: 'none',
    },
};

interface DeleteAccountDialogProps {
    open: boolean;
    onClose: () => void;
    onDeleted: () => void;
    loading: boolean;
}

const DeleteAccountDialog: React.FC<DeleteAccountDialogProps> = ({
    open,
    onClose,
    onDeleted,
    loading,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        maxWidth: 511,
                        padding: '22px',
                        borderRadius: '4px',
                        background: '#FFF',
                        outline: 'none',
                    },
                },
            }}
        >
            <DialogContent>
                <Box display="flex" mb={2}>
                    <TrashIcon
                        style={{
                            width: '28px',
                            height: '28px',
                            marginBottom: '8px',
                        }}
                    />
                </Box>
                <Typography variant="h6" style={{ fontWeight: 700, marginBottom: '16px' }}>
                    Delete Account
                </Typography>

                <Typography style={{ fontWeight: 400, marginBottom: '16px' }}>
                    Once you initiate account deletion:
                </Typography>

                <Typography style={{ fontWeight: 400, marginBottom: '16px' }}>
                    1. Your request will be sent to Convo.
                </Typography>

                <Typography style={{ fontWeight: 400, marginBottom: '16px' }}>
                    2. Our team will review and process it.
                </Typography>

                <Typography
                    style={{
                        fontWeight: 400,
                        marginBottom: '16px',
                        paddingLeft: '18px',
                        textIndent: '-18px',
                    }}
                >
                    3. You’ll receive a confirmation email once your account is deleted.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} sx={cancelButtonSx}>
                    Cancel
                </Button>
                <Button
                    onClick={onDeleted}
                    variant="contained"
                    sx={deleteButtonSx}
                    disabled={loading}
                >
                    {loading ? (
                        <CircularProgress size={24} color="inherit" />
                    ) : (
                        'Initiate Account Deletion'
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default DeleteAccountDialog;
